<template>
    <div id="home">
        <div class="music">
            <audio ref="music">
                <source src="/mp3/throw.mp3">
            </audio>
        </div>
        <div class="bgimg">
            <img src="/img/bgpic.png" alt="">
        </div>
        <div class="rotate">
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/yuanpan.png" alt=""
                 class="cir1">
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/guang.png" alt="" class="cir2">
        </div>
        <div class="gyps">
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/guanyin_new.png" alt="">
        </div>
        <div class="start">
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/kaishi_bj.png" alt=""
                 class="startbg">
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/kaishi_btn.png" alt=""
                 class="startbtn" @click="handledraw">
        </div>
        <div class="qiantong"><!--签字筒-->
            <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/fzlq/qiantong.png" alt="">
            <img src="/img/qinazi.png" alt="qianzi" class="qianzi">
        </div>
        <div class="black" ref="black"></div>
        <div class="alert" ref="alert">
            <div class="alertqianzi">
                <img src="/img/qian.png" alt="" class="alertqianzi">
                <ul class="qiannumber">
                    <li v-for="(item,index) in qianData.img" :key="index">
                        <img :src="item">
                    </li>
                </ul>
            </div>
            <div class="yun">
                <img src="/img/yun1.png" alt="yun1">
                <img src="/img/yun2.png" alt="yun2">
            </div>
            <div class="qiantext">
                <p>第{{qianData.num}}签</p>
            </div>
            <div class="tips" @click="handletoggle">
                <p>请连续掷出三次圣杯后进行解签</p>
                <p>
                    圣杯
                    <img src="/img/explan.png" ref="explain" class="explain hide">
                    <img src="/img/tips.png" ref="tips">
                    <img src="/img/close.png" ref="close" class="hide">
                </p>
            </div>
            <div class="beginbtn">
                <img src="/img/startthrow.png" class="throw" @click="handlethrow">
            </div>
        </div>
        <div id="throw" ref="threethrow">
            <div class="title">
                <p>第{{qianData.num}}签</p>
            </div>
            <div class="down downanimate" ref="down">
                <img v-for="(item,index) in moondata"
                     :src="item.src"
                     :class="item.class"
                     :key="index"
                     ref="moon"
                >
            </div>
            <p class="dec" ref="dec">
                0次掷杯
            </p>
            <div class="doitagain">
                <img src="/img/startthrow.png" alt="" @click="handlethrowagain" ref="startthrow">
                <img src="/img/untie.png" alt="" ref="untie" @click="handleUntie">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        components: {},
        data() {
            return {
                qianData: {
                    num: '',
                    img: [
                        '/img/di.png'
                    ]
                },
                thrownum: 0,
                againswitch: true,
                moondata: [
                    {
                        src: '/img/orangemoon.png',
                        class: 'moonanimate'
                    },
                    {
                        src: '/img/redmoon.png',
                        class: 'moonanimate'
                    }
                ],
                oid: ''
            };
        },
        methods: {
            //页面宽度函数
            handleSetFontSize() {
                let oHtml = document.getElementById('gyjq');
                fontSize();
                window.onresize = fontSize;

                function fontSize() {
                    oHtml.style.fontSize = window.innerWidth >= 750 ? 75 + 'px' : oHtml.style.fontSize;
                }

                document.cookie = 'age=125;SameSite=Lax'
            },
            //开始晃动事件
            handledraw() {
                const _this=this;
                //数据请求
                this.Axios({
                    url: '/?ct=app&ac=getlq',
                    method: 'post',
                }).then(res => {
                    this.qianData.num = res.data.data.qid;
                    this.qianData.img = this.qianData.img.concat(res.data.data.img);
                    this.Axios.get(`/?ct=app&ac=addorder&id=${res.data.data.id}`,{
                        params:{
                            cp:this.$route.query.cp
                        }
                    }).then(res=>{
                        this.oid=res.data.data.oid;
                    }).catch(err=>{
                        console.log(err);
                    })
                });
                let Qiantong = document.querySelector('.qiantong');
                let blck = document.querySelector('.black');
                Qiantong.style.display = 'block';
                blck.style.display = 'block';
                setTimeout(() => {
                    Qiantong.style.display = 'none';
                    this.$refs.alert.style.transition = `top 3s`;
                    this.$refs.alert.style.top = `0`;
                }, 5000)
                this.handlemusicplay();
            },
            //音乐播放事件
            handlemusicplay() {
                let music = this.$refs.music;
                music.play();
            },
            //说明点击隐藏/显示事件
            handletoggle() {
                this.$refs.tips.classList.toggle('hide');
                this.$refs.close.classList.toggle('hide');
                this.$refs.explain.classList.toggle('hide');
            },
            //掷杯事件函数
            handlethrow() {
                this.$refs.alert.style.transition = ``;
                this.$refs.alert.style.display = `none`;
                this.$refs.threethrow.style.display = `block`;
                this.handlethrowagain();
            },
            //多次掷杯函数
            handlethrowagain() {
                if (this.againswitch == false) return;
                this.againswitch = false
                //取消动画
                this.$refs.down.classList.remove('downanimate');
                this.$refs.moon.forEach((ele, index) => {
                    ele.classList.remove('moonanimate');
                })
                //页面重绘
                this.$refs.down.offsetLeft;
                //添加动画
                this.$refs.down.classList.add('downanimate');
                this.$refs.moon.forEach((ele, index) => {
                    ele.classList.add('moonanimate');
                })
                //更改描述
                setTimeout(this.handechangedeg, 2000);
            },
            //掷杯结果函数
            handechangedeg() {
                this.thrownum++;
                if (this.thrownum === 3) {
                    this.$refs.dec.innerText = `${this.thrownum}次掷杯为'圣杯',立即解签吧!`;
                    this.$refs.startthrow.style.display = 'none';
                    this.$refs.untie.style.display = 'block';
                } else {
                    this.$refs.dec.innerText = `${this.thrownum}次掷杯为'圣杯',请再次掷杯`;
                    this.againswitch = true;
                }
            },
            //跳转到付费页面
            handleUntie() {
                this.$router.push({
                    path: '/order',
                    query: {
                        oid: this.oid
                    }
                })
            }
        },
        created() {
            this.handleSetFontSize();
            this.$nextTick(() => {
                this.$refs.untie.style.display = 'none';
            })
        }
    }
</script>
<style lang="scss">
    //样式修改部分
    #home {
        position: relative;
        overflow: hidden;
        max-width: 750px;
        height: 100%;
        margin: 0 auto;

        .music {
            position: absolute;
            z-index: 0;
            top: 0;
            left: 0%;
        }

        .bgimg {
            position: relative;
            margin-top: 0;
            width: 100%;
            z-index: 2;

            img {
                display: block;
                width: 100%;
            }
        }

        .rotate {
            position: absolute;
            z-index: 5;
            top: 4rem;
            left: 10%;
            width: 80%;

            .cir1 {
                width: 100%;
            }

            .cir2 {
                position: absolute;
                z-index: 10;
                left: -21%;
                top: -35%;
                width: 140%;
                animation: rotate 10s infinite linear;
                -webkit-animation: rotate 10s infinite linear;
                -moz-animation: rotate 10s infinite linear;
                -o-animation: rotate 10s infinite linear;
            }
        }

        .gyps {
            position: absolute;
            z-index: 20;
            top: 5.6rem;
            left: 9.5%;
            width: 80%;

            img {
                width: 100%;
            }
        }

        .start {
            position: fixed;
            left: 50%;
            bottom: 0;
            z-index: 30;
            width: 8rem;
            height: 4rem;
            transform: translateX(-50%);

            .startbg {
                position: absolute;
                left: 0%;
                bottom: 0;
                width: 100%;
            }

            .startbtn {
                position: absolute;
                bottom: 6%;
                left: 36%;
                width: 28%;
                animation: scalebs 2s infinite linear;
                -webkit-animation: scalebs 2s infinite linear;
                -moz-animation: scalebs 2s infinite linear;
                -o-animation: scalebs 2s infinite linear;
            }
        }

        .qiantong {
            display: none;
            position: absolute;
            z-index: 40;
            bottom: 20%;
            width: 24%;
            left: 38%;
            transform-origin: bottom;
            animation: Wobble 4s;
            -webkit-animation: Wobble 4s;
            -moz-animation: Wobble 4s;
            -o-animation: Wobble 4s;

            img {
                width: 100%
            }

            img:nth-child(1) {
                position: relative;
                z-index: 45;
            }

            .qianzi {
                position: absolute;
                z-index: 41;
                right: 24%;
                top: 0.16rem;
                z-index: 40;
                width: 0.36rem;
                animation: Drop 1s linear;
                -webkit-animation: Drop 1s linear;
                -moz-animation: Drop 1s linear;
                -o-animation: Drop 1s linear;
                animation-delay: 3.2s;
                -webkit-animation-delay: 3.2s;
                -moz-animation-delay: 3.2s;
                -o-animation-delay: 3.2s;
            }
        }

        .black {
            position: absolute;
            display: none;
            z-index: 35;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.8);
        }
    ;

        .alert {
            position: absolute;
            z-index: 60;
            top: 100%;
            width: 100%;
            height: 100%;
            base: cubic-bezier(.09, .66, .85, .55);

            .alertqianzi {
                position: relative;
                width: 1.5rem;
                margin: 0.6rem auto 0;

                img {
                    width: 100%;
                }

                .qiannumber {
                    position: absolute;
                    left: 28%;
                    top: 1.3rem;
                    width: 44%;
                    margin-top: 0.1rem;

                    li {
                        margin-top: 0.08rem;

                        img {
                            display: block;
                        }
                    }
                }
            }

            .yun {
                width: 100%;
                position: absolute;
                top: 4rem;

                img {
                    display: block;
                    width: 2.5rem;
                    animation: leftRiht 2s infinite linear;
                    -webkit-animation: leftRiht 2s infinite linear;
                    -moz-animation: leftRiht 2s infinite linear;
                    -o-animation: leftRiht 2s infinite linear;
                }

                img:nth-child(1) {
                    margin-left: 1.8rem;
                }

                img:nth-child(2) {
                    margin-top: 2rem;
                    margin-left: 5.8rem;
                }
            }
        }

        .qiantext {
            width: 8.4rem;
            height: 2.63rem;
            margin: 0.5rem auto 0;
            padding-top: 0.1rem;
            background-color: antiquewhite;
            background-image: url("https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/bencichouqian.png");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            > p {
                margin-top: 1rem;
                font-size: 0.8rem;
                letter-spacing: 0.1rem;
                font-weight: bold;
                color: #000;
            }
        }

        .tips {
            margin-top: 10px;
            display: flex;
            padding: 0 8%;
            justify-content: space-between;
            color: #fff;
            font-size: 28px;

            p:nth-child(2) {
                color: #ff3d29;

                img.explain {
                    position: absolute;
                    top: 7.5rem;
                    left: 8%;
                    width: 8.4rem;
                    margin-left: 0;
                    height: 280px;
                }

                img {
                    display: block;
                    float: right;
                    margin-top: 6px;
                    margin-left: 4px;
                    height: 30px;
                }

                img.hide {
                    display: none;
                }
            }
        }

        .beginbtn {
            width: 80%;
            margin: 0.6rem auto 0;

            img {
                display: block;
                width: 100%;
            }
        }

        #throw {
            display: none;
            position: absolute;
            z-index: 70;
            top: 1rem;

            .title {
                position: relative;
                overflow: hidden;
                z-index: 75;
                width: 8.4rem;
                height: 2.63rem;
                margin: 0 0.8rem;
                padding-top: 0.1rem;
                background-color: antiquewhite;
                background-image: url("https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/bencichouqian.png");
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;

                > p {
                    margin-top: 1rem;
                    font-size: 0.8rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                    color: #000;
                }
            }

            .downanimate {
                animation: downfour 2s linear;
                -webkit-animation: downfour 2s linear;
                -moz-animation: downfour 2s linear;
                -o-animation: downfour 2s linear;
                animation-fill-mode: forwards;
                -webkit-animation-fill-mode: forwards;
                -moz-animation-fill-mode: forwards;
                -o-animation-fill-mode: forwards;
            }

            .moonanimate {
                animation-fill-mode: forwards;
                -webkit-animation-fill-mode: forwards;
                -moz-animation-fill-mode: forwards;
                -o-animation-fill-mode: forwards;
                animation: rotatefour 2s linear;
                -webkit-animation: rotatefour 2s linear;
                -moz-animation: rotatefour 2s linear;
                -o-animation: rotatefour 2s linear;
            }

            .down {
                position: absolute;
                left: 3rem;
                right: 3rem;
                z-index: 71;

                img {
                    width: 1.5rem;
                }

                img:nth-of-type(1) {
                    margin-right: 0.6rem;
                    vertical-align: top;
                }

                img:nth-of-type(2) {
                    margin-top: 1rem;
                    vertical-align: center;
                }
            }

            .dec {
                margin-top: 6.5rem;
                letter-spacing: 0.04rem;
                color: #fff;
                font-size: 0.4rem;
            }

            .doitagain {
                width: 80%;
                margin: 0.3rem auto 0;

                img {
                    display: block;
                    width: 100%;
                }
            }
        }
    }

    //动画定义部分
    @keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @-moz-keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes scalebs {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }

    @-webkit-keyframes scalebs {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }

    @-moz-keyframes scalebs {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }

    @-o-keyframes scalebs {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }


    @keyframes Wobble {
        0% {
            transform: rotate(0);
        }
        14% {
            transform: rotate(-45deg);
        }
        28% {
            transform: rotate(45deg);
        }
        42% {
            transform: rotate(-45deg);
        }
        56% {
            transform: rotate(45deg);
        }
        70% {
            transform: rotate(-45deg);
        }
        85% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    @-webkit-keyframes Wobble {
        0% {
            transform: rotate(0);
        }
        14% {
            transform: rotate(-45deg);
        }
        28% {
            transform: rotate(45deg);
        }
        42% {
            transform: rotate(-45deg);
        }
        56% {
            transform: rotate(45deg);
        }
        70% {
            transform: rotate(-45deg);
        }
        85% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    @-moz-keyframes Wobble {
        0% {
            transform: rotate(0);
        }
        14% {
            transform: rotate(-45deg);
        }
        28% {
            transform: rotate(45deg);
        }
        42% {
            transform: rotate(-45deg);
        }
        56% {
            transform: rotate(45deg);
        }
        70% {
            transform: rotate(-45deg);
        }
        85% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    @-o-keyframes Wobble {
        0% {
            transform: rotate(0);
        }
        14% {
            transform: rotate(-45deg);
        }
        28% {
            transform: rotate(45deg);
        }
        42% {
            transform: rotate(-45deg);
        }
        56% {
            transform: rotate(45deg);
        }
        70% {
            transform: rotate(-45deg);
        }
        85% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(0);
        }
    }


    @keyframes Drop {
        0% {
            transform: rotate(0);
        }
        100% {
            right: -80%;
            top: 60%;
            transform: rotate(720deg);
        }
    }

    @-webkit-keyframes Drop {
        0% {
            transform: rotate(0);
        }
        100% {
            right: -80%;
            top: 60%;
            transform: rotate(720deg);
        }
    }

    @-moz-keyframes Drop {
        0% {
            transform: rotate(0);
        }
        100% {
            right: -80%;
            top: 60%;
            transform: rotate(720deg);
        }
    }

    @-o-keyframes Drop {
        0% {
            transform: rotate(0);
        }
        100% {
            right: -80%;
            top: 60%;
            transform: rotate(720deg);
        }
    }

    @keyframes leftRiht {
        0% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-10%);
        }
        50% {
            transform: translateX(0);
        }
        75% {
            transform: translateX(10%);
        }
        100% {
            transform: translateX(0);
        }
    }

    @-webkit-keyframes leftRiht {
        0% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-10%);
        }
        50% {
            transform: translateX(0);
        }
        75% {
            transform: translateX(10%);
        }
        100% {
            transform: translateX(0);
        }
    }

    @-moz-keyframes leftRiht {
        0% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-10%);
        }
        50% {
            transform: translateX(0);
        }
        75% {
            transform: translateX(10%);
        }
        100% {
            transform: translateX(0);
        }
    }

    @-o-keyframes leftRiht {
        0% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-10%);
        }
        50% {
            transform: translateX(0);
        }
        75% {
            transform: translateX(10%);
        }
        100% {
            transform: translateX(0);
        }
    }

    @keyframes rotatefour {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(1440deg);
        }
    }

    @-webkit-keyframes rotatefour {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(1440deg);
        }
    }

    @-moz-keyframes rotatefour {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(1440deg);
        }
    }

    @-o-keyframes rotatefour {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(1440deg);
        }
    }

    @keyframes downfour {
        0% {
            top: 0;
        }
        100% {
            top: 6rem;
        }
    }

    @-webkit-keyframes downfour {
        0% {
            top: 0;
        }
        100% {
            top: 6rem;
        }
    }

    @-moz-keyframes downfour {
        0% {
            top: 0;
        }
        100% {
            top: 6rem;
        }
    }

    @-o-keyframes downfour {
        0% {
            top: 0;
        }
        100% {
            top: 6rem;
        }
    }
</style>